import { render, staticRenderFns } from "./GerenciarBoletos.vue?vue&type=template&id=42c323ba&"
import script from "./GerenciarBoletos.vue?vue&type=script&lang=js&"
export * from "./GerenciarBoletos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports